
import { defineComponent, ref, onMounted, computed } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import router from "@/router";
import Designs, {
  exportDesignData,
  exportPDFDesigns,
} from "@/core/data/design";
import {
  Design,
  getDesigns,
  deleteDesign,
  cloneDesign,
} from "@/core/data/design";
import moment from "moment";
import store from "@/store";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { getUserById, getUsers } from "@/core/data/users";
import { getError } from "@/core/helpers/utils";
import { PERMISSION_MODULE_NAME } from "@/core/data/permission";
import PartyMultiselect from "@/components/all-multiselect/party-multiselect.vue";
import SeasonMultiselect from "@/components/all-multiselect/season-multiselect.vue";

export default defineComponent({
  name: "Design-listing",
  components: {
    Datatable,
    PartyMultiselect,
    SeasonMultiselect,
  },
  setup() {
    const checkedDesign = ref([]);
    const selectedStatus = ref("");

    let selectedItem = ref({});
    let selectedUser = ref();

    const total = ref<any>(0);
    const currentPage = ref<any>(1);
    const showSearchPanel = ref<boolean>(true);
    const selectAllDesign = ref<boolean>(false);
    const isLoading = ref<boolean>(true);
    const search = ref<string>("");
    const tableData = ref<Array<Design>>(Designs);
    const userList = ref<any>({});
    const searchData = ref<any>({});
    const userOptionList = ref<any>([]);
    const userIdList = ref<Array<any>>([]);
    const branch = ref([]);
    const course = ref([]);
    const universiteies = ref([]);
    const getListItems = function (pageNumber) {
      console.log("selectedUser.value", selectedUser.value);
      isLoading.value = true;
      if (pageNumber) {
        currentPage.value = pageNumber;
      }
      localStorage.setItem(
        "DesignListAPiFilterData",
        JSON.stringify({
          currentPage: currentPage.value,
          searchData: searchData.value,
          selectedStatus: selectedStatus.value,
          selectedUser: selectedUser.value,
        })
      );
      return new Promise((res, rej) => {
        getDesigns(
          currentPage.value,
          searchData.value,
          selectedStatus.value,
          selectedUser.value
        ).then((resObj: any) => {
          isLoading.value = false;
          total.value = resObj.count;
          tableData.value.splice(0, tableData.value.length, ...resObj.data);
          console.log("tableData", tableData.value);
          let promiseList: any = [];
          tableData.value.forEach((item) => {
            if (userIdList.value.indexOf(item.created_by) == -1) {
              userIdList.value.push(item.created_by);
              promiseList.push(getUserName(item.created_by));
            }
            Promise.all(promiseList).then(() => {
              res(resObj);
            });
          });
          console.log("tableData", tableData.value);
        });
      });
    };
    const getUserName = async function (id) {
      if (!userList.value[id]) {
        let userData = await getUserById(id);
        userList.value[id] = userData;
      }
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Designs Listing", ["Apps", "Designs"]);
      var designListAPiFilterData: any = localStorage.getItem(
        "DesignListAPiFilterData"
      );
      if (designListAPiFilterData) {
        setTimeout(() => {
          designListAPiFilterData = JSON.parse(designListAPiFilterData);
          currentPage.value = designListAPiFilterData.currentPage;
          searchData.value = designListAPiFilterData.searchData;
          selectedStatus.value = designListAPiFilterData.selectedStatus;
          selectedUser.value = designListAPiFilterData.selectedUser;
          getListItems(currentPage.value);
        }, 500);
      } else {
        getListItems(1);
      }
    });

    const clearFilter = () => {
      currentPage.value = 1;
      searchData.value = {};
      selectedStatus.value = "";
      selectedUser.value = "";
      getListItems(1);
    };

    const userListComputed = computed(() => {
      return [
        { id: "", name: "All" },
        ...userOptionList.value.map((item) => ({
          name: item.name,
          ...item,
        })),
      ];
    });

    const asyncUser = (query) => {
      console.log("query", query);
      getUsers(1, query).then((resObj: any) => {
        userOptionList.value.splice(
          0,
          userOptionList.value.length,
          ...resObj.data
        );
      });
    };
    const deleteFewSites = () => {
      checkedDesign.value.forEach((item) => {
        deleteDesign(item);
      });
      checkedDesign.value.length = 0;
    };
    const exportFewSites = () => {
      exportDesignData(
        selectAllDesign.value ? "all" : checkedDesign.value.join(",")
      ).then(() => {
        Swal.fire("Export!", "Your Design has been exported.", "success");
      });
    };
    const exportPDFDesignsHanlder = () => {
      exportPDFDesigns(
        selectAllDesign.value ? "all" : checkedDesign.value.join(",")
      ).then(() => {
        Swal.fire("Export!", "Your Design has been exported.", "success");
      });
    };
    const deleteDesignItem = (item) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          deleteDesign(item)
            .then(() => {
              Swal.fire("Deleted!", "Your Design has been deleted.", "success");
              getListItems(currentPage.value);
            })
            .catch((err) => {
              Swal.fire({
                html: getError(err),
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
              });
            });
        }
      });
    };
    const searchItems = () => {
      getListItems(1);
    };

    const setSelectedItem = (item) => {
      selectedItem.value = item;
    };

    const addDesign = (id, isCloned = false) => {
      if (id) {
        router.push({
          name: "apps-edit-design",
          params: { id: id },
          query: { isCloned: isCloned.toString() },
        });
      } else {
        router.push({ name: "apps-add-design" });
      }
    };

    const cloneDesignHandler = (id) => {
      if (confirm("Are You sure you want to clone this design?")) {
        cloneDesign(id).then((data) => {
          Swal.fire({
            text: "Design Cloned successfully!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          }).then(() => {
            setTimeout(() => {
              router.push({
                name: "apps-edit-design",
                params: { id: data.data.id },
              });
              searchItems();
            }, 200);
          });
        });
      }
    };
    const stockDesignItem = (id) => {
      router.push({ name: "apps-stock-design", params: { id: id } });
    };
    const materialDesignItem = (id) => {
      router.push({ name: "apps-material-design", params: { id: id } });
    };
    const onPageChange = (pageNumber) => {
      return getListItems(pageNumber);
    };

    const userData = computed(() => {
      return store.getters.currentUser;
    });

    const permissionData = computed(() => {
      return store.getters.currentPermission;
    });
    const hasCreate = computed(() => {
      return (
        userData.value.role == "ADMIN" ||
        permissionData.value[PERMISSION_MODULE_NAME.DESIGN].create
      );
    });
    const hasEdit = computed(() => {
      return (
        userData.value.role == "ADMIN" ||
        permissionData.value[PERMISSION_MODULE_NAME.DESIGN].update
      );
    });
    const hasDelete = computed(() => {
      return (
        userData.value.role == "ADMIN" ||
        permissionData.value[PERMISSION_MODULE_NAME.DESIGN].delete
      );
    });
    const hasStock = computed(() => {
      return (
        userData.value.role == "ADMIN" ||
        permissionData.value[PERMISSION_MODULE_NAME.DESIGN_STOCK].read
      );
    });
    const hasProductionCost = computed(() => {
      return (
        userData.value.role == "ADMIN" ||
        permissionData.value[PERMISSION_MODULE_NAME.PRODUCTION].show_cost
      );
    });
    const hasCost = computed(() => {
      return (
        userData.value.role == "ADMIN" ||
        permissionData.value[PERMISSION_MODULE_NAME.DESIGN].show_cost
      );
    });
    const hasMaterial = computed(() => {
      return (
        userData.value.role == "ADMIN" ||
        permissionData.value[PERMISSION_MODULE_NAME.MATERIAL].read
      );
    });
    const tableHeader = computed(() => {
      let columnsArr = [
        {
          name: " ",
          key: "checkbox",
          sortable: false,
        },
        {
          name: "Code",
          key: "code",
          sortable: false,
        },
        {
          name: "Image",
          key: "image",
          sortable: false,
        },
      ];

      if (hasProductionCost.value) {
        columnsArr.push({
          name: "Final Cost",
          key: "finalCost",
          sortable: false,
        });
      }
      if (hasEdit.value || hasDelete.value) {
        columnsArr.push({
          name: "Actions",
          key: "actions",
          sortable: false,
        });
      }
      return columnsArr;
    });

    const onClickBack = () => {
      router.back();
    };

    return {
      addDesign,
      setSelectedItem,
      selectedItem,
      tableData,
      tableHeader,
      deleteDesign,
      getDesigns,
      deleteDesignItem,
      search,
      searchItems,
      checkedDesign,
      deleteFewSites,
      moment,
      total,
      currentPage,
      isLoading,
      onPageChange,
      userData,
      hasCreate,
      hasEdit,
      hasStock,
      hasCost,
      hasDelete,
      hasMaterial,
      selectedStatus,
      getUserName,
      userList,
      userListComputed,
      selectedUser,
      asyncUser,
      exportFewSites,
      exportPDFDesignsHanlder,
      selectAllDesign,
      showSearchPanel,
      searchData,
      branch,
      universiteies,
      course,
      stockDesignItem,
      materialDesignItem,
      onClickBack,
      cloneDesignHandler,
      clearFilter,
    };
  },
});
